// Companies Module - Root Sagas
// This file aggregates all companies-related sagas

import watchCompaniesListSaga from './List/store/saga'
import watchCompaniesFormSaga from './Form/store/saga'

// Root saga for Companies module
export default [
  watchCompaniesListSaga(),
  watchCompaniesFormSaga(),
]

